import React from 'react';
import { FileText, File, Table, ChevronDown } from 'lucide-react';

const cardData = [
  {
    id: 'pdf',
    title: 'PDF Documents',
    subtitle: 'Sales decks, case studies',
    icon: <FileText size={14} />,
    color: '#F43F5E', // Rose/Red
    gradient: 'radial-gradient(circle at top left, rgba(244, 63, 94, 0.08) 0%, transparent 60%)'
  },
  {
    id: 'docx',
    title: 'DOCX Files',
    subtitle: 'Playbooks, scripts, notes',
    icon: <File size={14} />,
    color: '#38BDF8', // Sky/Blue
    gradient: 'radial-gradient(circle at top left, rgba(56, 189, 248, 0.08) 0%, transparent 60%)'
  },
  {
    id: 'csv',
    title: 'CSV Data',
    subtitle: 'Pricing sheets, ICP data',
    icon: <Table size={14} />,
    color: '#10B981', // Emerald/Green
    gradient: 'radial-gradient(circle at top left, rgba(16, 185, 129, 0.08) 0%, transparent 60%)'
  }
];

export function KnowledgeCards({ 
  selectedType, 
  onSelectType 
}: { 
  selectedType: string | null; 
  onSelectType: (type: string | null) => void 
}) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginBottom: '24px' }}>
      {cardData.map((card) => {
        const isSelected = selectedType === card.id;
        return (
          <div 
            key={card.id}
            onClick={() => onSelectType(isSelected ? null : card.id)}
            style={{ 
              backgroundColor: isSelected ? 'rgba(255,255,255,0.05)' : 'var(--admin-bg-container, #010204)',
              border: isSelected ? `1px solid ${card.color}80` : '1px solid var(--admin-card-border)',
              borderTop: `1px solid ${card.color}${isSelected ? '80' : '40'}`,
              borderRadius: '0',
              padding: '16px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundImage: card.gradient,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            className="hover:bg-white/5"
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ color: card.color }}>
                {card.icon}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: 'var(--admin-card-text)', fontSize: '12px', fontWeight: 700 }}>{card.title}</span>
                <span style={{ color: 'var(--admin-card-subtext)', fontSize: '10px', fontWeight: 500 }}>{card.subtitle}</span>
              </div>
            </div>
            
            <ChevronDown size={14} style={{ color: isSelected ? 'var(--admin-card-text)' : 'var(--admin-card-subtext)', transform: isSelected ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />
          </div>
        );
      })}
    </div>
  );
}
